import React from "react"

import styled from "styled-components"
import { device } from "breakpoints"

export const Wrapper = styled.div`
  margin-bottom: 20px;

  @media ${device.tablet} {
    margin-left: 35%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }

  @media ${device.desktop} {
    margin-top: -16px;
  }

  li {
    font-weight: 300;
    font-size: 16px;
    color: #5a5a5a;
    letter-spacing: 0.44px;
    line-height: 1.5;

    list-style-type: none;
    position: relative;
    margin-bottom: 18px;
    margin-left: 25px;
    @media ${device.desktop} {
      font-size: 20px;
      margin-bottom: 7px;
      margin-left: 29px;
    }

    ::before {
      content: "";
      height: 8px;
      width: 8px;
      background-color: ${props => props.theme.green};
      display: block;
      border-radius: 50%;
      position: absolute;
      top: 9px;
      left: -25px;

      @media ${device.desktop} {
        top: 11px;
        font-size: 20px;
        left: -30px;
      }
    }
  }
`

const ListModule = ({ items }) => {
  return (
    <Wrapper>
      {items.map((item, index) => {
        return <li key={index}>{item.text}</li>
      })}
    </Wrapper>
  )
}

export default ListModule
